<template>
  <svg class="lina-icon">
    <use :xlink:href="`#i-${name}`"></use>
  </svg>
</template>

<script>
import './svg'
export default {
  props: ['name']
}
</script>

<style lang="scss">
  .lina-icon { width: 1.2em; height: 1.2em; }
</style>
